import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import AccountSection from "./account-section";
import InformationSection from "./information-section";
import DocumentSection from "./document-section";
import {Get} from "../../../apis/api";
import {toast} from "react-toastify";


const Crew = () => {
  const [step , setStep] = useState(2)
  const [data, setData] = useState({})


  // const handleProfile = () => {
  //    Get("agent/profile", { ...data  })
  //     .then((res) => {
  //       setData(res.details?.data)
  //     })
  //     .catch(() => {
  //       toast.error("خطایی رخ داده");
  //     })
  //
  // };

  // useEffect(() => {
  //   handleProfile()
  // } ,[])


  const handleStep = () => {
    // eslint-disable-next-line default-case
    switch (step) {
      // case 1:
      //   return (
      //     <AccountSection data={data}/>
      //   )
      case 2:
        return (
          <InformationSection data={data}/>
        )
      case 3:
        return (
          <DocumentSection data={data}/>
        )
    }
  }

  return (
    <div className={"mb-10 ltr"}>
      <div className={"my-container rounded-lg flex justify-between items-center w-full"}>
        <div className={"flex gap-10"}>
          {/*<div onClick={() => setStep(1)} className={`text-gray-700 border-b-2 p-2 ${step === 1 ? " bg-main/5  border-primary-900 text-primary-900" : " border-transparent  "} font-medium cursor-pointer`}>*/}
          {/*  {"Account"}*/}
          {/*</div>*/}
          <div onClick={() => setStep(2)} className={`text-gray-700 border-b-2 p-2 ${step === 2 ? " bg-main/5  border-primary-900 text-primary-900" : " border-transparent  "} font-medium cursor-pointer`}>
            {"Additional Information"}
          </div>
          <div onClick={() => setStep(3)} className={`text-gray-700 border-b-2 p-2 ${step ===  3 ? " bg-main/5  border-primary-900 text-primary-900" : " border-transparent  "} font-medium cursor-pointer`}>
            {"Documents"}
          </div>
        </div>
      </div>
      {
        handleStep()
      }
      <div>

      </div>
    </div>
  );
};

export default Crew;
